import { ReadPanel } from "../readPanel";
import { rrWidget } from "../../rr-widget"

export class PageNav extends rrWidget{
    public initialLoadPaginationFlag;
    constructor() {
        super();
        this.filterby = rrWidget.prototype.filterby;
        this.langaugeby = rrWidget.prototype.langaugeby;
        this.brand = rrWidget.prototype.brand;
        this.locale = rrWidget.prototype.locale;
        this.sortby = rrWidget.prototype.sortby;
        this.initialLoadPaginationFlag = true;
    }

    addPaginationListener(totalPages: number, page: number, filterReviewCount?: number): string {
        let t= this;
        let readPanelObj = new ReadPanel(),
            prevSelector = document.querySelector('.kr-pagination-nav .prev'),
            nextSelector = document.querySelector('.kr-pagination-nav .next'),
            numbSelector = document.querySelector('.kr-pagination-nav .numb'),
            $reviewContainer =  document.querySelector('.kr-readpanel-reviews');
        if (prevSelector) {
            prevSelector.addEventListener('click', () => {
                let pgNum = parseInt(document.querySelector('.numb.active').getAttribute('data-page-number'))-2;
                if (pgNum<0) {
                    pgNum = 0;
                }
                rrWidget.prototype.pageNumber = pgNum;
                readPanelObj.renderElementOnceInViewPort(t.brand, t.locale, t.filterby, t.sortby, t.langaugeby, t.filterByImg,  pgNum,t.size, false, true);
                if(rrWidget.prototype.pageNumber >=1) {
                    t.pagingTextUpdate(totalPages, pgNum, t.size, filterReviewCount);
                }
                t.getPageNav(totalPages, pgNum );
                t.initialLoadPaginationFlag = false;
                t.addPaginationListener(totalPages, pgNum, filterReviewCount);
                if($reviewContainer) {
                    $reviewContainer.scrollIntoView({behavior: 'smooth', block: 'start'})
                }
            });
        }
        if (nextSelector) {
            nextSelector.addEventListener('click', () => {
                let pgNum = parseInt(document.querySelector('.numb.active').getAttribute('data-page-number'));
                readPanelObj.renderElementOnceInViewPort(t.brand, t.locale, t.filterby, t.sortby, t.langaugeby, t.filterByImg, pgNum,t.size, false, true);
                rrWidget.prototype.pageNumber = pgNum;
                t.initialLoadPaginationFlag = false;
                t.pagingTextUpdate(totalPages, pgNum, t.size, filterReviewCount);
                t.getPageNav(totalPages, pgNum );
                t.addPaginationListener(totalPages, pgNum, filterReviewCount);
                if($reviewContainer) {
                    $reviewContainer.scrollIntoView({behavior: 'smooth', block: 'start'})
                }
            });
        }
        if (numbSelector) {
            document.querySelectorAll('.kr-pagination-nav .numb').forEach(item => {
                item.addEventListener('click', (event) => {
                    let pageNo = parseInt(item.getAttribute('data-page-number'));
                    readPanelObj.renderElementOnceInViewPort(t.brand, t.locale, t.filterby, t.sortby, t.langaugeby, t.filterByImg, pageNo-1,t.size, false, true);
                    rrWidget.prototype.pageNumber = pageNo-1;
                    t.initialLoadPaginationFlag = false;
                    if(rrWidget.prototype.pageNumber >0) {
                        t.pagingTextUpdate(totalPages, pageNo-1, t.size, filterReviewCount);
                    }
                    t.getPageNav(totalPages, pageNo-1 );
                    t.addPaginationListener(totalPages, page, filterReviewCount);
                    if($reviewContainer) {
                        $reviewContainer.scrollIntoView({behavior: 'smooth', block: 'start'})
                    }
                });
            });
        }
        if (t.initialLoadPaginationFlag) {
            t.pagingTextUpdate(totalPages, page, t.size, filterReviewCount);
        }
        return;
    }

    getPageNav(totalPages: number, page: number): string {
        page +=1;
        let liTag = '';
        let active, disabled;
        let beforePage = page - 1;
        let afterPage = page + 1;
        if(page > 1){ //show the next button if the page value is greater than 1
            liTag += `<li><button class="btn prev kr-pagination-prev" title="Previous page"><span><svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" xml:space="preserve"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g></svg></span></button></li>`;
        }
        if(page == 1) {
            liTag += `<li><button  class="btn prev kr-pagination-prev kr-disabled" title="Previous page"><span><svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 492 492" xml:space="preserve"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"/></g></g></svg></span></button></li>`;
        }

        if(page > 2){ //if page value is less than 2 then add 1 after the previous button
            liTag += `<li><button  class="first numb" title="Page 1" data-page-number="1"><span>1</span></button></li>`;
            if(page > 3){ //if page value is greater than 3 then add this (...) after the first li or page
                liTag += `<li class="dots" title="dots"><span>...</span></li>`;
            }
        }

        for (let plength = beforePage; plength < afterPage+1; plength++) {
            if (plength > totalPages) { //if plength is greater than totalPage length then continue
                continue;
            }
            if (plength == 0) { //if plength is 0 than add +1 in plength value
                plength = plength + 1;
            }
            if(page == plength){ //if page is equal to plength than assign active string in the active variable
                active = "active kr-disabled";
                disabled= "disabled=true"
            }else{ //else leave empty to the active variable
                active = "";
                disabled = ""
            }
            if(plength>0) {
                var currentPageText = (active == "active kr-disabled" ? "Selected page "+plength: "Page "+plength);
                liTag += `<li><button  class="numb ${active}" ${disabled} title="${currentPageText}" data-page-number="${plength}" ><span aria-hidden="true">${plength}</span></button></li>`;
            }
        }

        if(page < totalPages - 1){ //if page value is less than totalPage value by -1 then show the last li or page
            if(page < totalPages - 2){ //if page value is less than totalPage value by -2 then add this (...) before the last li or page
                liTag += `<li class="dots" title="dots" aria-hidden="true"><span aria-hidden="true">...</span></li>`;
            }
            liTag += `<li><button  class="last numb" title="Page ${totalPages}" data-page-number="${totalPages}"><span aria-hidden="true">${totalPages}</span></button></li>`;
        }
        if (page < totalPages) { //show the next button if the page value is less than totalPage(20)
            liTag += `<li><button  class="btn next kr-pagination-next" title="Next page" ><span><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 256 256" xml:space="preserve"><g><g><polygon points="79.093,0 48.907,30.187 146.72,128 48.907,225.813 79.093,256 207.093,128 \t\t"/></g></g></svg></span></button></li>`;
        }
        if (page == totalPages) { //show the next button if the page value is less than totalPage(20)
            liTag += `<li><button  class="btn next kr-pagination-next kr-disabled" title="Next Page"><span><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 256 256" xml:space="preserve"><g><g><polygon points="79.093,0 48.907,30.187 146.72,128 48.907,225.813 79.093,256 207.093,128 \t\t"/></g></g></svg></span></button></li>`;
        }
        if(document.querySelector('.kr-pagination-nav ul')) {
            document.querySelector('.kr-pagination-nav ul').innerHTML = liTag; //add li tag inside ul tag
        }
        return liTag; //return the li tag
    }

    pagingTextUpdate(totalPages: number, pageNum : number, size: number, filterReviewCount?: number): void{
        let pagingText = document.querySelectorAll('.kr-pagination-text span');
        let startReviewCount = (pageNum * size)+1;
        let lastReviewCount = ((pageNum * size) + size) < filterReviewCount ? ((pageNum * size) + size) : filterReviewCount;
        let displayPagination = document.querySelector('#kr-pagination-display');
        if (pagingText[0]) {
            pagingText[0].innerHTML =  startReviewCount + "-"+ lastReviewCount;
        }
        if(pagingText[1]) {
            pagingText[1].innerHTML = JSON.stringify(filterReviewCount);
        }
        if(displayPagination !== null){
            //if(filterReviewCount === undefined || filterReviewCount === NaN){
                if(filterReviewCount === undefined || Number.isNaN(filterReviewCount)){
                displayPagination.classList.add('kr-hide');
            }else {
                displayPagination.classList.remove('kr-hide');
            }
        }
    }

}